export const defaultTenantId = 'default';
export const adminTenantId = 'admin';
